import { RootState } from '@/store/store';
import { ModuleTree } from 'vuex';
import { staticFileActions } from './static-file.actions';
import { staticFileGetters } from './static-file.getters';
import { staticFileMutations } from './static-file.mutations';
import { staticFileState } from './static-file.state';

export default {
  namespaced: true,
  state: staticFileState,
  getters: staticFileGetters,
  actions: staticFileActions,
  mutations: staticFileMutations,
} as ModuleTree<RootState>;
